import { StatusColor } from '@interacta-shared/util';
import {
    COLOR_CODE_MAP,
    getSuiteImageUrl,
    IExternalLink,
    IExternalLinksCategory,
    IExternalLinksCategoryType,
    LinkOpenMode,
} from './external-link.model';

interface RawExternalLink {
    id: number;
    label: string;
    url: string;
    openMode: LinkOpenMode;
    authRequired: boolean;
    pinned: boolean;
    colorCode?: string;
    imageUrl?: string;
}

interface RawExternalLinksCategory {
    id: number;
    label: string;
    type: IExternalLinksCategoryType;
    links?: RawExternalLink[];
}

const toExternalLink = (
    externalLink: RawExternalLink,
    type: IExternalLinksCategoryType,
): IExternalLink => {
    const resolvedColorCode = externalLink.colorCode
        ? COLOR_CODE_MAP.get(externalLink.colorCode as StatusColor)
        : undefined;

    if (ngDevMode && externalLink.colorCode && !resolvedColorCode) {
        console.warn(
            `[ExternalLinks] Unknown colorCode from API: "${externalLink.colorCode}". Add it to COLOR_CODE_MAP.`,
        );
    }

    return {
        id: externalLink.id,
        label: externalLink.label,
        url: externalLink.url,
        openMode: externalLink.openMode,
        authRequired: externalLink.authRequired,
        pinned: externalLink.pinned,
        colorCode: resolvedColorCode,
        imageUrl: externalLink.imageUrl ?? getSuiteImageUrl(type),
    };
};

const toExternalLinksCategory = (
    record: RawExternalLinksCategory,
): IExternalLinksCategory => {
    return {
        id: record.id,
        label: record.label,
        type: record.type,
        links: (record.links ?? []).map((link) =>
            toExternalLink(link, record.type),
        ),
    };
};

export const toExternalLinksCategories = (
    records: RawExternalLinksCategory[],
): IExternalLinksCategory[] => {
    return records.map((record) => toExternalLinksCategory(record));
};
